import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'redux/rootReducer';
import * as Sentry from "@sentry/react";

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export default function createReduxStore() {
    const store = createStore(
        rootReducer,
        compose(applyMiddleware(thunk), sentryReduxEnhancer)
    );
    return store;
}